import React from 'react';
import './Subscriptions.css';
import useBlockCheck from '../../hooks/useBlockCheck'; // Import the hook
import UserTopbar from '../UsersTopbar/UsersTopbar';

const Subscriptions = () => {
  useBlockCheck('user'); // 🔥 Prevents blocked users from accessing this page

  const monthlyRate = 100;
  const plans = [
    {
      id: 'month-1',
      title: '1 Month',
      subtitle: 'Great for quick learning goals',
      months: 1,
      highlight: false,
      features: ['Full access to all courses', 'Public-level explanations', 'Search history and saved results', 'Email support'],
    },
    {
      id: 'month-6',
      title: '6 Months',
      subtitle: 'Best value for steady progress',
      months: 6,
      highlight: true,
      features: ['Everything in 1 Month plan', 'Priority search speed', 'Draft and notes support', 'WhatsApp support'],
    },
    {
      id: 'year-1',
      title: '1 Year',
      subtitle: 'Built for long-term mastery',
      months: 12,
      highlight: false,
      features: ['Everything in 6 Months plan', 'Advanced learning summaries', 'Premium mentor matching', 'Early access to new features'],
    },
  ];

  return (
    <>
      <div className="subscriptions-topbar">
        <UserTopbar />
      </div>
      <div className="subscriptions-page">
        <div className="subscriptions-hero">
          <div className="launching-offer-strip">
            <span className="offer-tag">Launching Offer</span>
            <span className="offer-main">100% OFF</span>
            <span className="offer-note">Limited-time access on 6 Months plan</span>
          </div>

          <h1>Pick a plan that grows with your learning goals</h1>
          <p>
            Simple monthly options with smarter long-term savings. Choose your plan and start learning
            with confidence.
          </p>

          <div className="hero-points">
            <span>Instant access</span>
            <span>Secure payments</span>
            <span>Cancel anytime</span>
          </div>

        </div>

        <div className="pricing-grid">
          {plans.map((plan) => {
            const originalPrice = monthlyRate * plan.months;
            const isFreeOffer = plan.id === 'month-6';

            return (
              <div key={plan.id} className={`pricing-card ${plan.highlight ? 'popular' : ''}`}>
                {plan.highlight && <div className="popular-tag">Your Active Plan</div>}

                <h3>{plan.title}</h3>
                <p className="plan-duration">{plan.subtitle}</p>

                <div className="price-block">
                  <div className="price-line">
                    <p className={`price-final ${isFreeOffer ? '' : 'regular-price'}`}>
                      Rs {isFreeOffer ? 0 : originalPrice}
                    </p>
                    <p className="price-meta">
                      {isFreeOffer && (
                        <span className="price-original strike">Rs {originalPrice}</span>
                      )}
                      <span> /{plan.months} month{plan.months > 1 ? 's' : ''}</span>
                    </p>
                  </div>

                  {isFreeOffer ? (
                    <p className="price-discount">Launching Offer Applied: 100% OFF</p>
                  ) : null}

                  <ul className="plan-features">
                    {plan.features.map((feature) => (
                      <li key={feature}>{feature}</li>
                    ))}
                  </ul>
                </div>

                <button
                  type="button"
                  className={`choose-plan-btn ${plan.highlight ? 'active' : 'inactive'}`}
                >
                  {plan.highlight ? 'Claim Launch Offer' : 'Choose Plan'}
                </button>
                {!plan.highlight && (
                  <p className="plan-note">
                    Standard price: Rs {originalPrice}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default Subscriptions;
